export type CountyFacilities = {
  [countyName: string]: Facility[];
};

export type FacilityProgramProps =
| "saneProgram"
| "pediatricAcute"
| "pediatricNonAcute"
| "adolescentAcute"
| "adolescentNonAcute"
| "adultAcute"
| "adultNonAcute"
| "child"
| "ipv"
| "elder"
| "trauma"
| "suspect"
| "sane247Availability";

export type Facility = {
  type: FacilityType;
  servicedBy?: { [servicedCountyName: string]: string[] };
  servicedCounties?: string[];
  programs: { [program: string]: string };
} & Record<
  | "name"
  | "address"
  | "city"
  | "state"
  | "zip"
  | "county"
  | "website"
  | "email"
  | "tel"
  | "afterHoursTel"
  | "lat"
  | "long"
  | "serviceHours"
  | "ages"
  | "note",
  string
> & Record<FacilityProgramProps, boolean>;

export type FacilityType =
  | "Hospital"
  | "FEMC"
  | "Other Health Facility"
  | "Child Advocacy Center"
  | "Rape Crisis Center"
  | "Tex-TRAC Telehealth Support"
  | "Military";

export type NetworkFacility = {
  TYPE: FacilityType;
} & Record<
  | "NAME"
  | "ADDRESS"
  | "CITY"
  | "STATE"
  | "ZIP"
  | "COUNTY"
  | "WEBSITE"
  | "EMAIL"
  | "TELEPHONE"
  | "24 HOUR/AFTER HOURS PHONE"
  | "LATITUDE"
  | "LONGITUDE"
  | "NOTE"
  | "SANE PROGRAM"
  | "COUNTIES SERVED"
  | "ACUTE PEDIATRIC SEXUAL ASSAULT"
  | "NON-ACUTE PEDIATRIC SEXUAL ASSAULT"
  | "ACUTE ADOLESCENT SEXUAL ASSAULT"
  | "NON-ACUTE ADOLESCENT SEXUAL ASSAULT"
  | "ACUTE ADULT SEXUAL ASSAULT"
  | "NON-ACUTE ADULT SEXUAL ASSAULT"
  | "CHILD PHYSICAL ABUSE/NEGLECT"
  | "IPV"
  | "ELDER MALTREATMENT"
  | "TRAUMA"
  | "SUSPECT"
  | "READY FACILITY"
  | "HOURS OF SERVICE"
  | "24/7 SANE availability"
  | "AGES SERVED",
  string
>;
export type MarkerCoordinates = [number, number];

export const PROGRAM_SANE = "SANE PROGRAM";
export const PROGRAM_READY_FACILITY = "READY FACILITY";
export const PROGRAM_ADULT_ACUTE = "ACUTE ADULT SEXUAL ASSAULT";
export const PROGRAM_ADULT_NON_ACUTE = "NON-ACUTE ADULT SEXUAL ASSAULT";
export const PROGRAM_ADOLESCENT_ACUTE = "ACUTE ADOLESCENT SEXUAL ASSAULT";
export const PROGRAM_ADOLESCENT_NON_ACUTE = "NON-ACUTE ADOLESCENT SEXUAL ASSAULT";
export const PROGRAM_PEDIATRIC_ACUTE = "ACUTE PEDIATRIC SEXUAL ASSAULT";
export const PROGRAM_PEDIATRIC_NON_ACUTE = "NON-ACUTE PEDIATRIC SEXUAL ASSAULT";
export const PROGRAM_CHILD_ABUSE = "CHILD PHYSICAL ABUSE/NEGLECT";
export const PROGRAM_IPV = "IPV";
export const PROGRAM_ELDER_MALTREATMENT = "ELDER MALTREATMENT";
export const PROGRAM_TRAUMA = "TRAUMA";
export const PROGRAM_SUSPECT = "SUSPECT";
export const FACILITY_TYPE_CAC = "Child Advocacy Center";
export const FACILITY_TYPE_RCC = "Rape Crisis Center";
export const FACILITY_TYPE_TT = "Tex-TRAC Telehealth Support";
export const FACILITY_TYPE_OTHER = "Other Health Facility";
export const COUNTIES_SERVICED = "COUNTIES SERVED";
export const SERVICE_HOURS = "HOURS OF SERVICE";
export const AFTER_HOURS_TELEPHONE = "24 HOUR/AFTER HOURS PHONE";
export const SANE_24_7_AVAILABILITY = "24/7 SANE availability";
export const AGES_SERVED = "AGES SERVED";
